var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[(_vm.renderPage)?_c('div',{attrs:{"fluid":"md"}},[(_vm.hasEcommerce)?_c('transactionComp'):_c('no-permission')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }